export default __webpack_public_path__ + "static/media/user-icon.2419b5f4.svg";